module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event/event_personal_color-deb2b8826bad133ec294ba7076869584.jpg";